import React from 'react';
import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import { ArrowIcon } from '../../icons/arrow-icon';

export const createArrowColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'arrow',
  Header: <ArrowIcon />,
  Cell: ArrowIcon,
  width: 0.1,
});
